import { buildGicEditor } from "./buildGicEditor";
import { notify } from "./notify";
import { request } from "./request";
import { humanDate } from "./humanDate";
import { cModal } from "./modal";
import { lang, languages, status } from "../app";

const saveGicOrderButton = $(`<button id="saveGicOrderButton" class="uk-button uk-button-primary" data-button>Save new order</button>`);
export const presentGicItems = (author, userLevel) => {
	let isAdmin = userLevel === "admin";
	window.gicItems = window.gicItems
		.filter(item => item.langs[lang])
		.sort((a, b) => {
			let aVal = parseInt(a.langs[lang].position);
			let bVal = parseInt(b.langs[lang].position);
			if (aVal < bVal) {
				return -1;
			} else if (aVal > bVal) {
				return 1;
			}
			return 0;
		});
	// sort by position parameter

	$("#gic_editor_wrapper").addClass("hidden");
	// hide the editor if it's open from a previous edit

	let origGicPosHash = window.gicItems.map(item => item.langs[lang].position).join("");
	let newGicPosHash;
	const gicList = $("#gic_list").html("");
	if (isAdmin) {
		$(saveGicOrderButton).insertAfter("#gic_editor_wrapper").hide();
	}
	if (!isAdmin && !window.gicItems.length) {
		$("#community_links").hide();
		// section should collapse for non-admins when no items are found
	} else {
		window.gicItems.forEach((item, index) => {
			let id = item.id;
			let pos = item.langs[lang].position;
			item = item.langs[lang];
			gicList.append(`<div id="${id}" data-position="${pos}" class="gic_wrapper uk-width-1-2 uk-width-1-3@s">
                <div class="gic_date">${humanDate(item.pubTime)}</div>
                <div class="gic_publication"><a href="${item.link}" target="_blank" alt="link to ${item.headline}">${item.publication}</a></div>
                <div class="gic_headline"><a href="${item.link}" target="_blank" alt="link to ${item.headline}">${item.headline}</a></div>
                ${isAdmin ? `<span data-button class="gicEdit_button" uk-icon="icon: pencil"></span> <span data-button class="gicDelete_button" uk-icon="icon: trash"></span>` : ""}
            </div>`);
		});
		// GIC items are placed on the page
	}

	if (isAdmin) {
		saveGicOrderButton.off("click").on("click", async function (e) {
			e.preventDefault();
			let _gicItems = [];
			$(".gic_wrapper").each(function (index, _gicItem) {
				_gicItem = window.gicItems.find(_item => _item.id === $(_gicItem).attr("id"));
				_gicItem.langs[lang].position = (index + 1).toString();
				_gicItems.push(_gicItem);
			});
			_gicItems = _gicItems.map(_item => {
				return {
					PutRequest: {
						Item: _item
					}
				};
			});

			const pageSize = 25;
			function sendReq(params, index = 0) {
				return new Promise(async (resolve, reject) => {
					try {
						const response = await request(params);
						if (index + pageSize < params.data.length) {
							index = index + pageSize;
							params.data = _gicItems.slice(index, index + pageSize);
							resolve(sendReq(params, index));
						} else {
							resolve();
						}
					} catch (err) {
						reject(err);
					}
				});
			}
			let params = {
				reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
				data: _gicItems.slice(0, pageSize)
				// kick off batchWrite with first 25 items
			};
			notify("Saving new order");
			try {
				const response = await sendReq(params);
				notify("New order saved", "success");
				origGicPosHash = newGicPosHash;
				saveGicOrderButton.hide();
			} catch (err) {
				console.error("Error saving new order");
				saveGicOrderButton.hide();
				notify("There was an error saving the new order", "danger");
			}
		});
		// saveGicOrderButton click handler

		gicList
			.attr("uk-sortable", "true")
			.off("moved")
			.on("moved", function () {
				setTimeout(() => {
					newGicPosHash = [];
					gicList.find("[data-position]").each(function () {
						newGicPosHash.push($(this).attr("data-position"));
					});
					newGicPosHash = newGicPosHash.join("");
					if (newGicPosHash === origGicPosHash) {
						// order is same as on page load

						saveGicOrderButton.hide();
					} else {
						saveGicOrderButton.show();
					}
				}, 100);
			});
		// make gic items sortable for admins

		$(".gicEdit_button")
			.off("click")
			.on("click", function () {
				$("#gic_editor_wrapper").removeClass("hidden");
				buildGicEditor($(this).parents(".gic_wrapper").attr("id"), author, userLevel);
			});
		// edit GIC item click handler

		$(".gicDelete_button")
			.off("click")
			.on("click", async function () {
				let id = $(this).parents(".gic_wrapper").attr("id");
				let delTarget = window.gicItems.find(item => item.id === id);
				try {
					await cModal(`<h4>Just checking ...</h4>
                    <p>You are about to delete the ${languages[lang]}-language "In the Community" item with the following particulars:</p><p><span class="bold">Publication:</span> ${delTarget.langs[lang].publication}<br/><span class="bold">Date:</span> ${humanDate(delTarget.langs[lang].pubTime)}<br/><span class="bold">Headline:</span> ${delTarget.langs[lang].headline}<br/><span class="bold">Link:</span> ${delTarget.langs[lang].link}</p><p class="bold">Is this the plan?</p>`);
					const response = await request({
						reqId: "f7ace6c3-dc2b-47f4-9f08-b890a61739ea",
						id: id,
						datatype: "gic"
					});
					window.gicItems = window.gicItems.filter(item => item.id != id);
					notify(`"Gulfstream in the Community" item successfully deleted`, "success");
					presentGicItems(author, userLevel);
				} catch (err) {
					if (err) {
						console.error("Error deleting In the Community item:", err);
						notify("There was an error deleting this item", "danger");
					}
				}
			});
		// delete GIC item click handler
	}
};
// end presentGicItems function
